// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX
import * as React from 'react';
import * as ReactDom from 'react-dom';
import remove = require('lodash/remove');
import { updateFacet, initializeFacet } from './actions/app-actions';
import find = require('lodash/find');
import { ISearchFacet } from './objects/iSearchFacet';

interface IFilterProps {
    Name: string,
    Title: string,
    Items: Array<{ Text: string, Value: string }>,
    ApplicableResults: Array<number>,
    dispatch: any,
    onChange: Function,
    SectionIndex: number,
    facet: ISearchFacet,
    usingChecks: boolean,
    listDisplayFilterBy: any
}

interface IFilterState {
    appliedFilters: Array<{ Text: string, Value: string }>;
    expandedState: string;
    showAllFilters: boolean;
    oneSelected: boolean;
}

export class Filter extends React.Component<IFilterProps, IFilterState> {
    constructor(props) {
        super(props);
        this._getFilterId = this._getFilterId.bind(this);
        this._toggleFilters = this._toggleFilters.bind(this);
        this._displayAllFilters = this._displayAllFilters.bind(this);
        let appliedFilters = [];
        if (this.props.facet != undefined)
            appliedFilters = this.props.facet.search;
        this.state = {
            appliedFilters: appliedFilters,
            expandedState: "",
            showAllFilters: false,
            oneSelected: this.props.facet != undefined ? this.props.facet.search.length > 0 : false
        };
    }

    componentDidMount() {
        this.props.dispatch(initializeFacet(this.props.Name, this.state.appliedFilters));
        if (this.props.Items.length > 1 && (this.props.usingChecks || !this.state.oneSelected)) {
            this.props.listDisplayFilterBy(true);
        }
        else {
            this.props.listDisplayFilterBy(false);
        }
    }

    componentWillReceiveProps(newProps: IFilterProps) {
        this.setState({ oneSelected: newProps.facet != undefined ? newProps.facet.search.length > 0 : false })
    }

    render() {
        if (this.props.Items.length > 1 && (this.props.usingChecks || !this.state.oneSelected)) {
            return (
                <div className={'sidebar-filter-group' + this.state.expandedState}>
                    <h3 className="sidebar-filter-group-heading" onClick={this._toggleFilters}>{this.props.Title}</h3>
                    <ul>
                        {this.props.Items.map((item, i) =>
                            this._displayOrSkipFilter(item, i)
                        )}
                        {this._showMoreLessFilters(this.props.Items.length)}
                    </ul>
                </div>
            );
        }
        else
            return null;
    }

    _toggleFilter(item, event) {
        let checkedFilters = this.state.appliedFilters;
        if (event.target.checked) {
            checkedFilters.push(item);
        }
        else {
            remove(checkedFilters, (filter) => filter.Text == item.Text);
        }
        this.setState({ appliedFilters: checkedFilters, oneSelected: (!this.props.usingChecks && !this.state.oneSelected) }, () => {
            this.props.dispatch(updateFacet(this.props.Name, this.state.appliedFilters));
            if (typeof (this.props.onChange) === 'function') {
                this.props.onChange();
            }
        });
    }

    _getFilterId(i) {
        return 'filter-option-' + this.props.SectionIndex + '-' + i;
    }
    _toggleFilters() {
        //needs to be explicitly defined because the state is open by default on desktop/closed on mobile
        let newState = "";
        if (this.state.expandedState == "") {
            if (window.innerWidth < 768) {
                newState = " open";
            }
            else {
                newState = " closed";
            }
        }
        else if (this.state.expandedState == " open") {
            newState = "  closed";
        }
        else {
            newState = " open";
        }
        this.setState({ expandedState: newState });
    }

    _displayOrSkipFilter(filter, i) {
        var hiddenFilter = '';
        if (!this.state.showAllFilters) {
            hiddenFilter = 'hidden-filter';
        }
        if (this.props.ApplicableResults[i] == 0)
            return;
        if (i < 10) {
            return (
                <li key={i}>
                    {this._getFilterToggle(filter, i)}
                </li>
            );
        }
        else {
            return (
                <li key={i} className={hiddenFilter}>
                    {this._getFilterToggle(filter, i)}
                </li>
            );
        }
    }

    _showMoreLessFilters(count) {
        if (count > 10) {
            if (this.state.showAllFilters) {
                return (
                    <span className="show-more-less" onClick={this._displayAllFilters}>- Show Less</span>
                );
            }
            else {
                return (
                    <span className="show-more-less" onClick={this._displayAllFilters}>+ Show More</span>
                );
            }
        }
        else {
            return;
        }
    }

    _displayAllFilters() {
        var showHiddenFilters;
        if (this.state.showAllFilters) {
            showHiddenFilters = false;
        }
        else {
            showHiddenFilters = true;
        }
        this.setState({ showAllFilters: showHiddenFilters });
    }

    _getFilterToggle(filter, i) {
        if (this.props.usingChecks) {
            return (

                <div>
                    <input type="checkbox" id={this._getFilterId(i)} onChange={this._toggleFilter.bind(this, filter)} checked={find(this.state.appliedFilters, { Text: filter.Text }) != null} />
                    <label htmlFor={this._getFilterId(i)}>
                        {filter.Text} ({this.props.ApplicableResults[i]})
                </label>
                </div>
            );
        }
        else {
            return (
                <div>
                    <input type="checkbox" id={this._getFilterId(i)} className="hide-checkbox" aria-hidden="true" onChange={this._toggleFilter.bind(this, filter)} checked={find(this.state.appliedFilters, { Text: filter.Text }) != null} />
                    <label htmlFor={this._getFilterId(i)}>
                        {filter.Text} ({this.props.ApplicableResults[i]})
                </label>
                </div>
            );
        }
    }
}